import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { ContractorStatus } from '@umss/shared/data-access';

/**
 * DTO for searching and filtering contractors with pagination support.
 * Maps to backend ContractorSearchDto.
 */
export interface ContractorSearchDto {
  // Search and basic filters
  searchTerm?: string;
  scopeOfPractice?: ScopeOfPracticeEnum;
  isAvailable?: boolean;
  status?: ContractorStatus;
  isVerified?: boolean;
  isFavorite?: boolean;

  // Rating and experience filters
  minRating?: number;
  minYearsExperience?: number;

  // Location filters
  latitude?: number;
  longitude?: number;
  radiusMiles?: number;
  stateCode?: string;
  facilityIdForDistance?: string; // Calculate distance from this facility

  // Context filters (role-based)
  corporateId?: string;
  facilityId?: string;
  facilityIds?: string[];
  contractorId?: string;

  // Pagination
  pageNumber?: number;
  pageSize?: number;

  // Sorting
  sortBy?: string;
  sortDescending?: boolean;
}
